import ScrollingTextItem from '@/components/sections/builder/elements/body/scrolling-text/scrolling-text-item';
import ElementContent from '@/components/sections/builder/elements/body/scrolling-text/content';
import ElementSetting from '@/components/sections/builder/elements/body/scrolling-text/setting';
import { ScrollingTextElementDataType } from '@/components/sections/builder/elements/body/scrolling-text/types';
import { Type } from 'lucide-react';

const defaultData: ScrollingTextElementDataType = {
  name: 'Scrolling Text',
  duration: 10,
  direction: 'left',
  fontSize: 'small',
  padding: {
    top: 16,
    bottom: 16,
    left: 0,
    right: 0,
  },
};

export const ElementPreviewIcon = Type;

const ScrollingText = {
  type: 'scrolling_text',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [ScrollingTextItem],
  childs: [ScrollingTextItem],
};

export const ScrollingTextHeader = {
  type: 'scrolling_text_header',
  group: 'header',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [ScrollingTextItem],
  childs: [ScrollingTextItem],
};

export default ScrollingText;
